module.exports = __webpack_public_path__ + "static/media/gallery-2-10.7aed17df.jpg";